import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

// Load existing credentials
export const fetchCredentials = createAsyncThunk(
  "credentials/fetchCredentials",
  async ({ license_key }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${baseURL}/emis_pathology/api/fetch_credentials/`,
        { license_key },
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

// Save/update credentials
export const saveCredentials = createAsyncThunk(
  "credentials/saveCredentials",
  async (
    { license_key, username, password, organization },
    { rejectWithValue },
  ) => {
    try {
      const res = await axios.post(
        `${baseURL}/emis_pathology/api/save_credentials/`,
        {
          license_key,
          username,
          password,
          organization,
        },
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

const credentialsSlice = createSlice({
  name: "credentials",
  initialState: {
    creds: null,
    status: "idle",
    error: null,
    message: null,
    deploymentType: "filer",
  },
  reducers: {
    clearMessage: (state) => {
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCredentials.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCredentials.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.creds = action.payload;
      })
      .addCase(fetchCredentials.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(saveCredentials.pending, (state) => {
        state.status = "saving";
        state.error = null;
        state.message = null;
      })
      .addCase(saveCredentials.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.message;
      })
      .addCase(saveCredentials.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearMessage } = credentialsSlice.actions;
export default credentialsSlice.reducer;
